export default {
  Quote: 'Quote',
  Company: 'Company'
}